# Which clientAPI call is the STEP-UP PASSWORD CONFIRMATION itself?
#
# Lives here, as a plain CommonJS module, for the same reason as
# serverErrorMessage.coffee and credentialOperations.coffee: client_api.coffee
# is ESM at module scope, so a test harness cannot require it, and this is a
# rule about the framework's auth surface rather than a detail of one caller.
#
# THE DEFECT THIS EXISTS FOR (card 6a6e30adb6fa565d7504b9c6). authModel.reauth
# throws {status: 401, message: 'Invalid Credentials'} on a wrong password. Its
# route is `<Model>Reauth` (model.coffee builds route_name + http.path), which
# does NOT match client_api's auth-branch selector /^[^.]+Auth$/ — that pattern
# is case-sensitive and 'Reauth' ends in a lowercase 'auth' — and the
# operationId `User.reauth` contains no '.login'. So the refusal fell into the
# GENERIC catch, whose self-instance-401 arm reads a 401 as "your session
# expired" and runs clearUser() + hash='/login' + reload.
#
# The consequence, reproduced live on ripperws2 2026-08-01: mistyping your
# password once in the step-up dialog DESTROYS the session it was trying to
# elevate — the dialog's own catch never runs, because the page is already
# gone. That is exactly the failure mode card 6a6d3803d3bc5a01f6ed7ac4 forbade
# on the login branch, sitting one route over.
#
# WHY MATCH THE OPERATION AND NOT THE BODY. The 401s reauth can throw are
# 'Invalid Credentials' (wrong password) and 'Permission Denied' (no usable
# token). Only the second is a real session failure, and telling them apart
# needs a discriminator the server does not currently send — bodies are bare
# strings on this path (model.coffee sends {message, code} only for allowlisted
# codes). Keying on the operation instead conflates the two, and conflates them
# in the SAFE direction: the worst case is that an admin whose session really
# did die sees "Password not accepted" once, and the very next request they
# make 401s and logs them out normally. The opposite trade — a mistyped
# password ending a valid session — is the defect being fixed.
#
# reauthStatus is DELIBERATELY NOT INCLUDED, though the card named it. It
# carries no password, so it has no wrong-password 401 to protect; the only way
# it answers 401 is a session that genuinely cannot authenticate, and that is
# precisely when logging out is the correct behavior. Adding it would leave an
# admin with a dead session sitting on a screen that never says so.
#
# operationId is "Model.method", and the model name is app-defined (User,
# Student, Agent, …), so the METHOD half is what identifies the call.
isStepUpConfirmation = (operationId) ->
  /\.reauth$/.test String(operationId or '')

module.exports = {isStepUpConfirmation}
